import { useEffect } from 'react'
import { rangeCircleFeature } from '../../utils/rangeCircle'

export function useRangeCircle(map, { rangeMode, rangeCenter, rangeRadiusKm }) {
  useEffect(() => {
    if (!map.current || !map.current.getLayer('regions-fill')) return
    const feature = rangeMode && rangeCenter
      ? rangeCircleFeature([rangeCenter.lng, rangeCenter.lat], rangeRadiusKm)
      : null
    const area = { type: 'FeatureCollection', features: feature ? [feature] : [] }
    const center = {
      type: 'FeatureCollection',
      features: feature ? [{
        type: 'Feature', properties: {},
        geometry: { type: 'Point', coordinates: [rangeCenter.lng, rangeCenter.lat] },
      }] : [],
    }

    if (!map.current.getSource('range-circle')) {
      map.current.addSource('range-circle', { type: 'geojson', data: area })
      map.current.addLayer({
        id: 'range-circle-fill', type: 'fill', source: 'range-circle',
        paint: { 'fill-color': '#e9b949', 'fill-opacity': 0.16 },
      })
      map.current.addLayer({
        id: 'range-circle-line', type: 'line', source: 'range-circle',
        paint: { 'line-color': '#e9b949', 'line-width': 3, 'line-dasharray': [2, 1] },
      })
      map.current.addSource('range-circle-center', { type: 'geojson', data: center })
      map.current.addLayer({
        id: 'range-circle-center', type: 'circle', source: 'range-circle-center',
        paint: { 'circle-radius': 5, 'circle-color': '#e9b949', 'circle-stroke-color': '#111', 'circle-stroke-width': 2 },
      })
    } else {
      map.current.getSource('range-circle').setData(area)
      map.current.getSource('range-circle-center').setData(center)
    }
  }, [map, rangeMode, rangeCenter, rangeRadiusKm])
}
